import React from 'react';

const AllReviewsPopup = ({ reviews, onClose }) => {
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-start pt-12 px-2">
            <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-6xl max-h-[90vh] overflow-y-auto">
                <div className="flex justify-between items-center mb-4">
                    <h3 className="text-2xl font-semibold text-purple-700">All Reviews</h3>
                    <button
                        onClick={onClose}
                        className="text-red-500 font-bold text-lg hover:text-red-700"
                    >
                        ✕
                    </button>
                </div>
                <div className="flex flex-wrap gap-4 justify-between mt-8 overflow-hidden">
                    {reviews.filter(review => review.showHide).map((review) => (
                        <div
                            key={review._id}
                            className="
                basis-full
                sm:basis-[48%]
                md:basis-[32%]
                max-w-full
                sm:max-w-[48%]
                md:max-w-[32%]
                border p-4 rounded-lg shadow-md relative pb-7 bg-white
            "
                        >
                            <h3 className="font-bold text-lg text-purple-600">{review.reviewTitle}</h3>
                            <p className="text-gray-600 mt-1">{review.review}</p>
                            <div className="flex items-center space-x-1 text-yellow-400 mt-2">
                                {Array.from({ length: review.rating }, (_, i) => (
                                    <span key={i}>⭐</span>
                                ))}
                            </div>

                            {review.reviewImage && (
                                <img crossOrigin="anonymous" 
                                    src={review.reviewImage}
                                    alt="Review"
                                    className="mt-3 rounded-md object-cover w-full h-auto max-h-48"
                                />
                            )}
                            <p className="text-purple-500 text-sm absolute bottom-2">By: {review.name}</p>
                        </div>
                    ))}
                </div>


            </div>
        </div>
    );
};

export default AllReviewsPopup;
